type Step = {
  number: string
  icon: string
  title: string
  description: string
}

const STEPS: Step[] = [
  { number: '1', icon: 'ti ti-nfc', title: 'Tap', description: 'A student taps their RFID ID card on the gate reader.' },
  { number: '2', icon: 'ti ti-user-check', title: 'Verify', description: "Gatekeeper instantly verifies the student's identity." },
  { number: '3', icon: 'ti ti-clipboard-check', title: 'Log', description: 'A time-stamped entry or exit is recorded automatically.' },
  { number: '4', icon: 'ti ti-send', title: 'SMS sent', description: 'The parent or guardian is notified by SMS.' },
]

// #how-it-works — the tap -> verify -> log -> SMS flow as four numbered steps.
export const HowItWorksSection = () => {
  return (
    <section className="section-custom bg-light bg-opacity-30 border-top border-bottom border-light" id="how-it-works">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <span className="text-muted rounded-3 d-inline-block">How it works</span>
            <h2 className="mt-3 fw-bold mb-5">
              From tap to <mark className="fst-italic">parent alert</mark> in seconds
            </h2>
          </div>
        </div>

        <div className="row g-4 justify-content-center">
          {STEPS.map((step) => (
            <div className="col-md-6 col-lg-3" key={step.number}>
              <div className="text-center px-3">
                <div className="avatar-xl mx-auto mb-3 position-relative">
                  <span className="avatar-title text-bg-primary rounded-circle fs-22">
                    <i className={step.icon}></i>
                  </span>
                  <span className="badge bg-primary-subtle text-primary rounded-pill position-absolute top-0 start-100 translate-middle">
                    {step.number}
                  </span>
                </div>
                <h4 className="mb-2">{step.title}</h4>
                <p className="text-muted mb-0">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
